//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ColumnSettings',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Array,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  mounted: function mounted() {
    this.$refs.columnTable.$refs.WeforsysTable.toggleAllSelection();
  },
  methods: {
    handleRowClick: function handleRowClick(row) {
      this.$refs.columnTable.$refs.WeforsysTable.toggleRowSelection(row);
    },
    columnSelectionChange: function columnSelectionChange(val) {
      this.$emit('change', val);
    }
  }
};